import React, { useCallback } from 'react';
import { connect } from "react-redux";
import { useTranslation } from 'react-i18next';
import UnifiedModal from '../UnifiedModal';

function ContactUsModal({dispatch, dir, shouldShow, setModalVisible}) {
  const { t } = useTranslation();

  const handleClose = useCallback(() => setModalVisible(false), [setModalVisible]);

  const footerButtons = [
    {
      variant: 'primary',
      onClick: handleClose,
      children: t("noQuestions")
    },
    {
      href: `https://wa.me/972546127601?text=${t("contactUsMessageText")}${encodeURIComponent(window.location)}`,
      target: '_blank',
      onClick: handleClose,
      variant: 'secondary',
      children: t("contactUsOnWhatsapp")
    }
  ];

  return (
    <UnifiedModal
      show={shouldShow}
      onHide={handleClose}
      title={t("contactUsTitle")}
      dir={dir}
      footerButtons={footerButtons}
    >
      {t("contactUsText")}
    </UnifiedModal>
  );
}

const mapStateToProps = ({ ui }) => ({
  dir: ui.direction,
});

export default connect(mapStateToProps)(ContactUsModal);